module.exports = __webpack_public_path__ + "static/mordenkainen_s_faithful_hound_mtg_afr-4f69af7fb8ee0e3f7feedf6be871b880.jpg";